export type AlfredWithdrawalErrorKind =
  | "mfa_missing"
  | "mfa_invalid"
  | "passkey_missing"
  | "passkey_invalid"
  | "method_required"
  | "other";

export interface ParsedAlfredWithdrawalError {
  kind: AlfredWithdrawalErrorKind;
  /** Server-provided message, or null when the request failed without one. */
  message: string | null;
}

// REST drops AppException.code/vars (the HTTP filter sends only the message), so the kind is read from the message text.
export const parseAlfredWithdrawalError = (err: unknown): ParsedAlfredWithdrawalError => {
  const detail = (err as { detail?: unknown } | null | undefined)?.detail;
  const message = typeof detail === "string" && detail.trim() ? detail : null;
  const text = message ?? "";

  let kind: AlfredWithdrawalErrorKind = "other";
  if (/no verification method configured/i.test(text)) kind = "method_required";
  else if (/missing mfa token/i.test(text)) kind = "mfa_missing";
  else if (/entered mfa token is invalid/i.test(text)) kind = "mfa_invalid";
  else if (/missing passkey/i.test(text)) kind = "passkey_missing";
  else if (/entered passkey is invalid/i.test(text)) kind = "passkey_invalid";

  return { kind, message };
};
